// extracted by mini-css-extract-plugin
module.exports = {"MyBucketListPage":"MyBucketListPage_MyBucketListPage__ed_JG","ListItem":"MyBucketListPage_ListItem___FE5P"};